import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import s from './link.module.css';
import { useRel, useVariant } from './utils';
var Link = function Link(_ref) {
  var href = _ref.href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? 'self' : _ref$target,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$text = _ref.text,
    body = _ref$text === void 0 ? true : _ref$text,
    _ref$external = _ref.external,
    external = _ref$external === void 0 ? false : _ref$external,
    onClick = _ref.onClick,
    externalRel = _ref.rel,
    gtm = _ref.gtm,
    dataTest = _ref.dataTest,
    _ref$visited = _ref.visited,
    visited = _ref$visited === void 0 ? false : _ref$visited;
  var variants = useVariant(variant);
  var rel = useRel(externalRel, target);
  return React.createElement("a", {
    className: classNames.apply(void 0, [s.reset, body && s.body, visited && s.visited].concat(_toConsumableArray(variants.map(function (v) {
      return s[v];
    })))),
    href: href,
    target: '_' + target,
    rel: rel,
    "data-test": dataTest,
    "data-gtm": gtm,
    onClick: onClick
  }, children, body && external && React.createElement("span", {
    className: s.external
  }, React.createElement(Icon, {
    name: "square-arrow",
    size: "s"
  })));
};
export default Link;